import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import styles from './styles';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

class QueryResults extends Component {
  state = {
    selected: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.state !== this.props.state) {
      this.setState({
        selected: false
      })
    }
  }

  selectCustomer = customerId => {
    const {
      onSelect
    } = this.props;

    this.setState({
      selected: customerId,
    }, () => {
      onSelect(customerId);
    })
  };

  render () {
    const {
      state,
      total,
      customers,
      error,
      classes
    } = this.props;
    const {
      selected
    } = this.state;

    if (false === state) {
      return null;
    }

    if ('request' === state) {
      return (
        <Paper className={classNames(classes.paper, classes.centred)}>
          <CircularProgress />
        </Paper>
      )
    }

    if ('fail' === state) {
      return (
        <Paper className={classNames(classes.paper, classes.centred)}>
          Error: {error || 'Unknown'}
        </Paper>
      )
    }

    if (0 === total) {
      return (
        <Paper className={classNames(classes.paper, classes.centred)}>
          0 customers found matching criteria
        </Paper>
      )
    }

    return (
      <Paper className={classNames(classes.paper, classes.centred)}>
        <div>
          {total} customer{1 === total ? '' : 's'} found matching criteria
        </div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Customer Number</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>Phone Number(s)</TableCell>
              <TableCell>{' '}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(customers).map(key => {
              const customer = customers[key],
                name = customer.name || {},
                address = customer.address || {},
                phoneNumbers = customer['phone-numbers'] || {},
                addNotSelectedClassName = selected && selected !== customer.id
              ;

              return (
                <TableRow key={customer.id} className={classNames(addNotSelectedClassName && classes.tableRowNotSelected)}>
                  <TableCell>{customer['customer-number']}</TableCell>
                  <TableCell>{name.title} {name['first-name']} {name['last-name']}</TableCell>
                  <TableCell>{[
                      address['line-1'],
                      address['line-2'],
                      address['line-3'],
                      address['line-4'],
                      address['locality'],
                      address['town'],
                      address['county'],
                    ].filter(value => !!value).join(', ')}. {address['post-code']}
                  </TableCell>
                  <TableCell>
                    {[
                      phoneNumbers.home,
                      phoneNumbers.mobile
                    ].filter(value => !!value).join(', ')}
                  </TableCell>
                  <TableCell>
                    <Button
                      color="primary"
                      variant="outlined"
                      type="submit"
                      fullWidth
                      onClick={() => this.selectCustomer(customer.id)}
                    >
                      Select
                    </Button>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </Paper>
    )
  }
}

QueryResults.propTypes = {
  total: PropTypes.number.isRequired,
  customers: PropTypes.objectOf(
    PropTypes.object
  ).isRequired,
  state: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]).isRequired,
  error: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default withStyles(styles)(QueryResults);



// WEBPACK FOOTER //
// ./src/components/Query/QueryResults.js